import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreDomainsModule,
  DatastoreActiveLanguagesModule,
  DatastoreLanguagesModule,
  DatastoreUsersSelfModule,
} from '@freelancer/datastore/collections';
import { PwaModule } from '@freelancer/pwa';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { LanguageSwitcherInlineComponent } from './language-switcher-inline.component';
import { LanguageSwitcherLinkComponent } from './language-switcher-link.component';
import { LanguageSwitcherComponent } from './language-switcher.component';
import { LanguageSwitcher } from './language-switcher.service';

@NgModule({
  imports: [
    CommonModule,
    DatastoreDomainsModule,
    DatastoreActiveLanguagesModule,
    DatastoreLanguagesModule,
    TrackingModule,
    UiModule,
    PwaModule,
    DatastoreUsersSelfModule,
  ],
  providers: [LanguageSwitcher],
  declarations: [
    LanguageSwitcherComponent,
    LanguageSwitcherLinkComponent,
    LanguageSwitcherInlineComponent,
  ],
  exports: [LanguageSwitcherComponent],
})
export class LanguageSwitcherModule {}
